/**
 * React Query keys. Keys for outcomes, payments and claims carry `staleTime: 0` semantics in `query.ts`
 * (§4.4 no optimistic UI); feature agents reuse these so invalidation works across routes.
 */
export const queryKeys = {
  lottery: (slug: string) => ['lottery', slug] as const,
  receipt: (entryId: string) => ['entry', entryId, 'receipt'] as const,
  paymentStatus: (paymentId: string) => ['payment', paymentId, 'status'] as const,
  results: (slug: string) => ['lottery', slug, 'results'] as const,
  fairness: (drawId: string) => ['draw', drawId, 'fairness'] as const,
  referral: (code: string) => ['referral', code] as const,
  claimCurrent: () => ['claim', 'current'] as const,
  claimCatalog: () => ['claim', 'current', 'catalog'] as const,
  claimStatus: () => ['claim', 'current', 'status'] as const,
  winLink: (winId: string) => ['win', winId] as const,
} as const;
